import React, { FC } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { redirectTo } from 'omni-package-react-core';
import { PersonalInformation } from '../../../interfaces/PersonalInformation';
import Name from '../../_Name';
import BirthDate from '../../_BirthDate';
import Gender from '../../_Gender';
import Emails from './Emails/Emails';
import Address from '../../_Address';
import CareOf from '../../_CareOf';

import Phones from './Phones';
import Correspondence from './Correspondence';
import { StyledButton } from './Content.styles';
import Constants from '../../../Constants';
import { PersonalInfoResourceInfo } from '../../PersonalInformationResource/PersonalInformationResource';

export interface ContentProps { }

const Content: FC<ContentProps> = () => {
  const navigate = useNavigate();
  const personalInfo: PersonalInformation = useScopedSelector(PersonalInfoResourceInfo.dataDst);
  const { t } = useTranslation('PersonalInformationsTile');
  return (
    <>
      <Name personalInfo={personalInfo} withButton />
      <BirthDate personalInfo={personalInfo} />
      <Gender personalInfo={personalInfo} />
      <CareOf personalInfo={personalInfo} />
      <Emails personalInfo={personalInfo} />
      <Phones personalInfo={personalInfo} />
      <Address personalInfo={personalInfo} />
      <Correspondence personalInfo={personalInfo} />
      <StyledButton outline onClick={() => redirectTo(Constants.PersonalInformationsIntroductionPagePath, navigate)}>{t('modifyButtonLabel')}</StyledButton>
    </>
  );
};
export default Content;
